import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import classNames from "classnames";
import Stack from "@mui/material/Stack";
import {
  TextField,
  InputLabel,
  Input,
  Button,
  Autocomplete,
  TextareaAutosize,
} from "@mui/material";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
//import {  } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
//import CurrencyFormat from 'react-currency-format';
import CurrencyInput from "react-currency-input-field";
import { addfinancerec } from "../actions/VivoFinanceActions";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";
import categories from "../assets/data/categories.json";
import descriptions from "../assets/data/descriptions.json";
import paymentmethods from "../assets/data/paymentmethods.json";
import paytos from "../assets/data/paytos.json";
import invoicefiles from "../assets/data/invoicefiles.json";
import currencies from "../assets/data/currencies.json";
import Notification from "../components/Notification";
import styles from "assets/jss/vivoleo-react-kit/views/componentsSections/addRecordScreenStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import AddRemoveCat from "./AddRemoveCat";

const useStyles = makeStyles(styles);

export default function ReportItem(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const redirect = "/addfinancerec";
  const [selectedCategories, setSelectedCategories] = useState(["all"]);
  const [reportItem, setReportItem] = useState();
  const [updateBtnShow, setUpdateBtnShow] = useState(true);
  console.log("categories:");

  const dispatch = useDispatch();

  useEffect(() => {}, [props.history, redirect]);
  const confirmedCategory = (addedCategories, onConfirmed) => {
    if (onConfirmed) {
      console.log("Selected Categories:" + selectedCategories);
    } else {
      console.log("no Selected Categories:");
    }
    setSelectedCategories(addedCategories);
    addReportCategories(reportItem, selectedCategories);
    console.log("reportItem:" + reportItem);
    //setAddedCatIDs(addedCatIDs);
  };

  const addReportCategories = (itemname, inputcat) => {
    props.ItemReprotingCategory(itemname, inputcat);
  };

  return (
    <div>
      <div className={classes.space30}> </div>
      <GridContainer justify="center" className={classes.contentText}>
        <GridItem xs={12} sm={12} md={4}>
          <div className={classes.textCenter}>
            <InputLabel
              htmlFor="ItemName"
              className={classNames(classes.upperCase, classes.subTitle)}
            >
              Item Name Included The report
            </InputLabel>
            <div className={classes.space30}> </div>
            <Input
              id="reportitem"
              placeholder="Input Item Name "
              required
              sx={{ width: "100%" }}
              onChange={(e) => {
                setReportItem(e.target.value);
                setUpdateBtnShow(false);
              }}
            ></Input>
          </div>
          <div className={classes.space30}> </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <div className={classes.textCenter}>
            <InputLabel
              htmlFor="ReportCategory"
              className={classNames(classes.upperCase, classes.subTitle)}
            >
              Please Select Categories For Reporting
            </InputLabel>

            <AddRemoveCat confirmedCategory={confirmedCategory} />
            <div className={classes.space30}> </div>
            <TextareaAutosize
              maxRows={4}
              aria-label="maximum height"
              placeholder="Maximum 4 rows"
              defaultValue={selectedCategories}
              style={{ width: "100%" }}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <div className={classes.space30}> </div>
          <Button
            disabled={updateBtnShow}
            onClick={() => {
              addReportCategories(reportItem, selectedCategories);
            }}
            variant="outlined"
            size="small"
          >
            Add This Item To Report
          </Button>
        </GridItem>
      </GridContainer>
    </div>
  );
}
